import { useSnackbar } from 'notistack';
import { useCallback, useMemo } from 'react';

import { NotificationMessage } from 'types/snackbar';

export const useNotifications = () => {
    const { enqueueSnackbar } = useSnackbar();

    const handleShow = useCallback(
        ({ variant = 'default', ...options }: NotificationMessage) => {
            enqueueSnackbar({ ...options, variant });
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [],
    );

    return useMemo(() => ({ show: handleShow }), [handleShow]);
};
